import {db} from '@/firebase'
import {mostrarIdioma, createSlug} from '@/utils/utils.js'

export default {
    getCategorias({commit,rootState}){
        let negocio = rootState.app.negocioGest;
        let devolver = [];
        return db.collection('negocios').doc(negocio).collection('categorias').get()
        .then((res) => {
            res.forEach(doc => {
                let aux = doc.data();
                aux.id = doc.id;
                devolver.push(aux);
            });
            commit('setCategoriasArray',devolver)
        })
    },
    addCategoria({rootState},cat){
        let negocio = rootState.app.negocioGest
        var id;
        if (!cat.id){
            let nombre_lang = mostrarIdioma(cat.nombre);
            id = createSlug(nombre_lang);
        } else {
            id = cat.id;
        }
        delete cat.negocio;
        delete cat.id;
        return db.collection('negocios').doc(negocio).collection('categorias').doc(id).set(cat,{merge:true})
        
    },
    ordenarCategorias({rootState},array){
        let negocio = rootState.app.negocioGest;
        let arrayPromesas = [];
        array.forEach(element => {
            arrayPromesas.push(
                db.collection('negocios').doc(negocio)
                .collection('categorias')
                .doc(element.id)
                .set({orden:element.orden},{merge:true})
            )
        });
        return arrayPromesas;
    },
    deleteCategoria({commit,rootState},item){
        let negocio = rootState.app.negocioGest;
        return db.collection('negocios').doc(negocio).collection('categorias').doc(item.id).delete();
    },
}